import { useState, useEffect, lazy, Suspense } from "react";
import { X } from "lucide-react";

const DiagnosticQuiz = lazy(() => import("@/components/DiagnosticQuiz"));

const STORAGE_KEY = "yesod_popup_last_shown";
const COOLDOWN_DAYS = 14;
const DELAY_MS = 2 * 60 * 1000; // 2 minutes

const LeadPopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const lastShown = localStorage.getItem(STORAGE_KEY);
    if (lastShown) {
      const diff = Date.now() - Number(lastShown);
      if (diff < COOLDOWN_DAYS * 24 * 60 * 60 * 1000) return;
    }

    const timer = setTimeout(() => {
      setVisible(true);
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    }, DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  const close = () => setVisible(false);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" dir="rtl">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-foreground/60 backdrop-blur-sm animate-in fade-in-0 duration-300"
        onClick={close}
      />

      {/* Card */}
      <div className="relative z-10 w-full max-w-md rounded-2xl border border-border bg-card shadow-2xl animate-in zoom-in-95 slide-in-from-bottom-4 duration-300 overflow-hidden">
        {/* Top accent bar */}
        <div className="h-1.5 w-full gradient-accent" />

        {/* Close */}
        <button
          onClick={close}
          className="absolute left-3 top-4 rounded-full p-1.5 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors z-10"
          aria-label="סגור"
        >
          <X size={18} />
        </button>

        <div className="p-6 pt-5">
          <Suspense fallback={<div className="h-40 flex items-center justify-center text-muted-foreground">טוען...</div>}>
            <DiagnosticQuiz sourcePage="popup_lead" onClose={close} />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default LeadPopup;
